import { Dropdown, Col, Row, Space, Typography, Modal, Button, message } from "antd";
import IndustriesView from "../components/IndustriesView";
import { useState } from "react";
import IndustryFormDialog from "../components/IndustryFormDialog";
import { CompanyIndustriesForm } from "../components/IndustriesView.default";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getCompanyIndustriesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function IndustriesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [industryInputMode, setIndustryInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [industryInputOpen, setIndustryInputOpen] = useState(false);
  const [industryInputValues, setIndustryInputValues] =
    useState<CompanyIndustriesForm>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onIndustryInputOpen(
    mode: "add" | "update" | "delete",
    values?: CompanyIndustriesForm,
  ): void {
    setIndustryInputMode(mode);
    setIndustryInputOpen(true);
    setIndustryInputValues(values || ({} as any));
  }

  function onIndustryInputFinish(): void {
    setIndustryInputOpen(false);
    setIndustryInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onIndustryInputClose(): void {
    setIndustryInputOpen(false);
    setIndustryInputValues({} as any);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading industry export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getCompanyIndustriesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Industries
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("CompanyDomains", "create")}

            className={`${!permissions.can("CompanyDomains", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("CompanyDomains", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onIndustryInputOpen("add")}
          >
            Add Industry
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <IndustriesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onIndustryInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <IndustryFormDialog
        mode={industryInputMode}
        open={industryInputOpen}
        initialValues={industryInputValues}
        onFinish={onIndustryInputFinish}
        onCancel={onIndustryInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default IndustriesPage;
